import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { AccountService } from "@done/ngx-essentials";
import { LOGIN_ROUTE } from "./shared/login-route.constant";
import { AuthGuardService } from "./shared/auth-guard.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private _router: Router,
    private readonly _accountService: AccountService,
    private readonly _authGuardService: AuthGuardService,
  ) {}

  ngOnInit(): void {
    this._accountService.userLoggedOut.subscribe(() =>
      this._router.navigate([LOGIN_ROUTE]),
    );

    this._accountService.accountSelected.subscribe({
      next: () => {
        this._authGuardService
          .canAccess(this._accountService.selectedAccount?.id)
          .subscribe({
            next: (canAccess) => {
              if (!canAccess) {
                this._accountService.logout().subscribe(() => {
                  alert(
                    "Essa conta não possui permissão para utilizar o done! Pointer.",
                  );
                });
              }
            },
          });
      },
    });
  }
}
